import React from 'react';
import { IconProps } from './type';

export function ChevronDown({ color = 'currentColor', ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55806 9.55806C6.80214 9.31398 7.19786 9.31398 7.44194 9.55806L12 14.1161L16.5581 9.55806C16.8021 9.31398 17.1979 9.31398 17.4419 9.55806C17.686 9.80214 17.686 10.1979 17.4419 10.4419L12.4419 15.4419C12.1979 15.686 11.8021 15.686 11.5581 15.4419L6.55806 10.4419C6.31398 10.1979 6.31398 9.80214 6.55806 9.55806Z"
        fill={color}
      />
    </svg>
  );
}
